<template>
  <div
    class="main-content"
    :class="{
      'main-content--left-sidebar-present': leftSidebar,
      'main-content--right-sidebar-present': rightSidebar
    }"
  >
    <div class="main-content__overlay"></div>
    <transition name="fast-fade" mode="in-out">
      <img v-if="backgroundAssetType === 'image' && backgroundImage" class="main-content__background" :key="backgroundImage" :src="`${$store.state.assetsPath}${backgroundImage}`">
      <video
        v-if="backgroundAssetType === 'video' && backgroundImage"
        :key="backgroundImage"
        class="main-content__background"
        :src="`${$store.state.assetsPath + backgroundImage}`"
        autoplay
        muted
        loop
      ></video>
    </transition>
    <slot></slot>
  </div>
</template>
<script>
export default {
  props: ['backgroundImage', 'left-sidebar', 'right-sidebar'],

  computed: {
    backgroundAssetType () {
      if (!this.backgroundImage) return false
      if (this.backgroundImage.split('.').pop() === 'mp4') {
        return 'video'
      } else {
        return 'image'
      }
    }
  }
}
</script>
<style lang="scss">
@import "@/styles/_variables.scss";
@import "node_modules/tiny-slider/src/tiny-slider";

.main-content {
  width: 192rem;
  height: 98rem;
  position: absolute;
  top: 0;
  left: 0;

  &__overlay {
    height: 100%;
    opacity: .5;
    pointer-events: none;
    position: relative;
    z-index: 1000;

    &::after {
      background: linear-gradient(270deg, 
        rgba(0, 0, 0, 1) 0%,
        rgba(0, 0, 0, 0.738) 19%,
        rgba(0, 0, 0, 0.541) 34%,
        rgba(0, 0, 0, 0.382) 47%,
        rgba(0, 0, 0, 0.278) 56.5%,
        rgba(0, 0, 0, 0.194) 65%,
        rgba(0, 0, 0, 0.126) 73%,
        rgba(0, 0, 0, 0.075) 80.2%,
        rgba(0, 0, 0, 0.042) 86.1%,
        rgba(0, 0, 0, 0.021) 91%,
        rgba(0, 0, 0, 0.008) 95.2%,
        rgba(0, 0, 0, 0.002) 98.2%,
        rgba(0, 0, 0, 0) 100%
      );
      bottom: 0;
      content: '';
      right: 0;
      position: absolute;
      top: 0;
      width: $overlay-gradient-width;
      z-index: 10;
    }
  }

  &__background {
  height: 100%;
  left: 0;
  object-fit: cover;
  pointer-events: none;
  position: absolute;
  top: 0;
  width: 100%;
}

  &--right-sidebar-present {
    width: 159.5rem;
  }

  &--left-sidebar-present {
    width: 159.5rem;
  }

  .main--right-sidebar-present.main--left-sidebar-present {
    width: 159.5rem;
  }
}
</style>
